import { Redirect } from "wouter";
import { useAuth } from "../hooks/useAuth";
import { Wordmark } from "../components/Brand";
import { BottomNav } from "../components/BottomNav";

/**
 * Discover — Phase 2 placeholder. The "browse merchants by vertical /
 * geography" UX lands in Wave 2; for now this tab confirms the bottom-
 * nav scaffold is wired and gives the user a sense of what's coming.
 */
export function DiscoverPage() {
  const { isAuthenticated } = useAuth();
  if (!isAuthenticated) return <Redirect to="/" />;

  return (
    <div className="min-h-screen pb-28">
      <div className="mx-auto max-w-md px-6 pt-10">
        <header className="flex items-center justify-between">
          <Wordmark size="sm" />
        </header>

        <section className="mt-8">
          <h1 className="text-2xl font-bold text-navy">Discover</h1>
          <p className="mt-1 text-sm text-ink-dark">
            Find new M42 merchants near you.
          </p>
        </section>

        <section className="mt-8 card text-center">
          <div className="mx-auto h-14 w-14 rounded-full bg-amber-light/60 flex items-center justify-center">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={1.8}
              className="h-7 w-7 text-amber"
              aria-hidden="true"
            >
              <circle cx="12" cy="11" r="3" />
              <path d="M12 2c-4.5 0-8 3.5-8 8 0 5.5 8 12 8 12s8-6.5 8-12c0-4.5-3.5-8-8-8z" />
            </svg>
          </div>
          <h2 className="mt-4 text-lg font-semibold text-navy">Coming soon</h2>
          <p className="mt-2 text-sm text-ink-dark">
            We&apos;re curating a directory of carwashes, salons, kainan and more.
            For now, scan any M42 merchant&apos;s Join QR to add a card.
          </p>
        </section>
      </div>
      <BottomNav />
    </div>
  );
}
